import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { ActivatedRoute } from '@angular/router';
// import { ChooseIconComponent } from '../../choose-icon/choose-icon.component';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
// import { FunctionService  } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';

import { ChooseIconComponent, } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
interface OpenMap {
  [name: string]: {
    open: boolean;
    menuChild: {
      [itemMenu: string]: boolean;
    };
  };
}

@Component({
  selector: 'app-icon-admin-config',
  templateUrl: './icon-admin-config.component.html',
  styleUrls: ['./icon-admin-config.component.scss']
})
export class AtwIconAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() config: any = {}; // là desktop_config hoặc mobile_config
  @Input() class: any;  // là desktop_class hoặc mobile class
  @Input() objectChoosing: any; // xác định object hiệu ứng đang chọn để cấu hình
  @Input() staticdata: any;  // biến lưu staticdata trong json.
  @Input() type_config: string;
  @Input() type: any;
  @Input() device: any; // xác định thiết bị 
  @Output() closeConfigTool = new EventEmitter();
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  @Input() blocks_of_page?: any;
  @Output() iconSelected = new EventEmitter<any>();
  isViewAll = false; // biến check để mở thêm các confg ở phần mở rộng 
  effect_hover = []; // danh sách các hiệu ứng
  customize = [];  // biến lưu hiệu ứng được chọn
  effect_hover_data: any = {}; // dữ liệu tất cả hiệu ứng
  currentViewAll = { title: '', index: 0 };
  id_subproject: any;
  textareaValue: string = '';
  dataAfterChange: any = {};
  styles_field = [
    {
      title: 'dieu_chinh_vien',
      index: 1,
    },
    {
      title: 'hieu_ung',
      index: 2,
    },
    {
      title: 'lat_hinh',
      index: 3,
    },

  ];
  fileList: NzUploadFile[] = [

  ];
  configMode: 'basic' | 'advanced' = 'basic';

  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`
  };
  parserDeg = (value: string): string => value.replace('°', '');
  formatterDeg = (value: number): string => {
    return `${value} °`
  };


  constructor(
    private dialog: MatDialog,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    private vhImage: VhImage,
        public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/data/effects/icon.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    });
  }

  ngOnChanges(): void {
    this.staticdata.icon_type ??= 'mat_icon';
    if (this.staticdata.icon_type == 'icon') {
      this.staticdata.icon_type = 'mat_icon';
    }
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {}; 
    
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  parsePx(value: string | undefined): number {
    if (!value) return 0;
    return parseFloat(value.replace('px', '')) || 0;
  }

  /**
   * Lấy fontSize từ width tổng và từ viền, khoảng đệm
   */
  getFontSizeFromWidth(w?) {
    const getVal = (key) => parseFloat(this.class.icon[key] || '0') || 0;
    
    const width = w ?? getVal('width');

    const borderLeft = getVal('border-left-width');
    const borderRight = getVal('border-right-width');
    const borderTop = getVal('border-top-width');
    const borderBottom = getVal('border-bottom-width');

    const padLeft = getVal('padding-left');
    const padRight = getVal('padding-right');
    const padTop = getVal('padding-top');
    const padBottom = getVal('padding-bottom');

    // Chiều rộng khả dụng = Tổng rộng - (Border trái/phải + Padding trái/phải)
    const availableWidth = width - (borderLeft + borderRight + padLeft + padRight);
    
    // Chiều cao khả dụng = Tổng cao - (Border trên/dưới + Padding trên/dưới)
    const availableHeight = width - (borderTop + borderBottom + padTop + padBottom);

    // Lấy số nhỏ nhất giữa Ngang và Dọc để đảm bảo icon không bị tràn theo chiều nào cả
    // Math.max(0, ...) để tránh trường hợp border/padding quá to làm ra số âm
    return Math.max(0, Math.min(availableWidth, availableHeight));
  }

  /**
   * Chọn loại icon hiển thị
   */
  chooseTypeICon(value: any) {
    this.staticdata.icon_type = value;

    if (value == 'icon_svg' && !this.staticdata.icon_svg) {
      this.staticdata.icon_svg = '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 124 124" fill="none"><rect width="124" height="124" rx="24" fill="#F97316"/><path d="M19.375 36.7818V100.625C19.375 102.834 21.1659 104.625 23.375 104.625H87.2181C90.7818 104.625 92.5664 100.316 90.0466 97.7966L26.2034 33.9534C23.6836 31.4336 19.375 33.2182 19.375 36.7818Z" fill="white"/><circle cx="63.2109" cy="37.5391" r="18.1641" fill="black"/><rect opacity="0.4" x="81.1328" y="80.7198" width="17.5687" height="17.3876" rx="4" transform="rotate(-45 81.1328 80.7198)" fill="#FDBA74"/></svg>';
    }

    this.updateStaticData();
  }

  /**
   * Upload file SVG từ máy
   * @param event file upload từ máy
   */
  onFileSelected(event: any): void {
    const file = event.target.files[0];

    if (file && file.type.includes('svg')) {
      const reader = new FileReader();
      
      // Đọc file dưới dạng text (string) thay vì base64
      reader.readAsText(file); 
      reader.onload = (e: any) => {
        // Lấy nội dung raw SVG
        this.staticdata.icon_svg = e.target.result;
        this.updateStaticData();
      };
    } else {
      this.functionService.createMessage('error', 'vui_long_chon_file_svg', 4000);
    }
  }

  /**
   * Nhập Link URL
   * @param url
   */
  loadSvgFromUrl(url?: string): void {
    const urlTmp = url ?? this.staticdata.icon_svg_url;

    // Quan trọng: responseType phải là 'text' để lấy chuỗi XML/SVG
    this.http.get(urlTmp, { responseType: 'text' }).subscribe({
      next: (svgString) => {
        // Gán nội dung lấy được vào data
        this.staticdata.icon_svg = svgString;
        this.updateStaticData();
      },
      error: (err) => {
        this.functionService.createMessage('error', 'khong_the_tai_svg_tu_duong_dan_nay_kiem_tra_cors', 4000);
        console.error('Không thể tải SVG từ link này (Check CORS)', err);
      }
    });
  }

  /**
   * Chọn nguồn hiển thị icon svg
   */
  toggleIconSvgSource(event) {
    this.staticdata.icon_svg_source = event;
    
    switch (event) {
      case 'url': 
        if (!this.staticdata.icon_svg_url)
          this.staticdata.icon_svg_url = 'https://www.svgrepo.com/show/532036/cloud-rain-alt.svg';
        break;
      case 'svg_code': 
        if (!this.staticdata.icon_svg)
          this.staticdata.icon_svg = '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 124 124" fill="none"><rect width="124" height="124" rx="24" fill="#F97316"/><path d="M19.375 36.7818V100.625C19.375 102.834 21.1659 104.625 23.375 104.625H87.2181C90.7818 104.625 92.5664 100.316 90.0466 97.7966L26.2034 33.9534C23.6836 31.4336 19.375 33.2182 19.375 36.7818Z" fill="white"/><circle cx="63.2109" cy="37.5391" r="18.1641" fill="black"/><rect opacity="0.4" x="81.1328" y="80.7198" width="17.5687" height="17.3876" rx="4" transform="rotate(-45 81.1328 80.7198)" fill="#FDBA74"/></svg>';
        break;
    }

    this.updateStaticData();
  }

  openMap: OpenMap = {
    menu1: {
      open: true,
      menuChild: {}
    },
    menu2: {
      open: false,
      menuChild: {}
    },
    menu3: {
      open: false,
      menuChild: {
        // menu4: false, 
        menu5: false,
        menu6: false,
        menu7: false,
        menu8: false,
        menu9: false
      }
    },

  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key === value) {
        this.openMap[key].open = true;
      }
      this.openMap[key].open = false;
    }
    if (Object.keys(this.openMap['menu3'].menuChild).length !== 0) {
      for (let keyChild in this.openMap['menu3'].menuChild) {
        if (keyChild !== value) {
          this.openMap['menu3'].menuChild[keyChild] = false;
        }
      }
    }
  }

  /**
   * Hàm đóng
   */
  close() {
    this.updateClass();
    this.updateConfig()
    this.closeConfigTool.emit(null);
    this.isViewAll = false;
  }
  /**
   * Hàm mở ra hộp thoại chọn icon
   */
  openDialogChooseIcon() {
    this.visible_config_tool = false;
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.staticdata.icon = result.icon;
        this.staticdata.icon_active = true;
        this.staticdata.icon_svg_active = false;
        this.updateStaticData()
      }
      this.visible_config_tool = true;
    });
  }
  /**
   * Hàm update object vào database.
   */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     [this.device + '_class']: this.class,
  //     [this.device + '_config']: this.config,
  //     staticdata: this.staticdata
  //   }).then((bool: any) => {
  //     console.log('updateObject', bool);
  //   })
  // }
  /**
 *Hàm update class vào database.
  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     [this.device + '_class']: this.class
  //   }).then((bool: any) => {
  //     console.log('updateClass', bool);
  //   })

  // }
  /**
 *Hàm update config vào database.
  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
  //       console.log('updateConfig', bool);
  //     })
  // }
  /**
   * Cập nhật staticdata vào database.
   */
  // updateStaticData() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then((bool) => {
  //     });
  // }

  // hàm cập nhật bộ lọc hình ảnh
  updateFilter(value: any) {
    this.config.style_filter.filter_blur = value;
    this.class['icon__primary']['filter'] = "brightness(" + this.config.style_filter.filter_brightness + "%) "
      + "saturate(" + this.config.style_filter.filter_saturate + "%) "
      + "blur(" + this.config.style_filter.filter_blur + "px) "
      + "hue-rotate(" + this.config.style_filter.filter_hue_rotate + "deg) "
      + "contrast(" + this.config.style_filter.filter_contrast + "%) "
      + "opacity(" + this.config.style_filter.filter_opacity + "%) "
      + "grayscale(" + this.config.style_filter.filter_grayscale + "%) "

  }
  /**
   * Hàm cập nhật key và value của css
   * @param name 
   * @param key 
   */
  updateCss(name, key) {
    this.dataAfterChange[name] = { ...key }
  }
  /**
   * Cap nhat cho admin 
   */
  updateDynamic(name, value) {
    this.dataAfterChange[name] = value;
  }
  /**
   * Hàm kiểm tra đóng mở của menu config ở phần mở rộng
   */
  openViewAll(field) {
    this.currentViewAll = field;
    this.isViewAll = !this.isViewAll;
  }

  //Hàm biến đổi transform cho icon

  handleSetTransform(axis) {
    // switch (axis) {
    //   case 'x':       // ---Lật dọc
    //     if (this.config['transform'].transform_rotateX < 360) {
    //       this.config['transform'].transform_rotateX += 180;
    //       this.class['icon__primary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg)"
    //         + "rotateY(" + this.config['transform'].transform_rotateY + "deg)"
    //         + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg)"
    //         + "skewX(" + this.config['transform'].transform_skewX + "deg)"
    //         + "skewY(" + this.config['transform'].transform_skewY + "deg)"
    //     }
    //     else
    //       this.config['transform'].transform_rotateX -= 180;
    //     this.class['icon__primary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg)"
    //       + "rotateY(" + this.config['transform'].transform_rotateY + "deg)"
    //       + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg)"
    //       + "skewX(" + this.config['transform'].transform_skewX + "deg)"
    //       + "skewY(" + this.config['transform'].transform_skewY + "deg)"
    //     break;
    //   case 'y':       // ---Lật ngang
    //     if (this.config['transform'].transform_rotateY < 360) {
    //       this.config['transform'].transform_rotateY += 180;
    //       this.class['icon__primary'].transform = "rotateX(" + this.config['transform'].transform_rotateY + "deg)"
    //         + "rotateY(" + this.config['transform'].transform_rotateY + "deg)"
    //         + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg)"
    //         + "skewX(" + this.config['transform'].transform_skewX + "deg)"
    //         + "skewY(" + this.config['transform'].transform_skewY + "deg)"
    //     }
    //     else {
    //       this.config['transform'].transform_rotateY -= 180;
    //       this.class['icon__primary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg)"
    //         + "rotateY(" + this.config['transform'].transform_rotateY + "deg)"
    //         + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg)"
    //         + "skewX(" + this.config['transform'].transform_skewX + "deg)"
    //         + "skewY(" + this.config['transform'].transform_skewY + "deg)"
    //     }
    //     break;
    //   case '-z':        // --- Xoay trái
    //     if (this.config['transform'].transform_rotateZ > -360) {
    //       this.config['transform'].transform_rotateZ -= 90;
    //       this.class['icon__primary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg)"
    //         + "rotateY(" + this.config['transform'].transform_rotateY + "deg)"
    //         + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg)"
    //         + "skewX(" + this.config['transform'].transform_skewX + "deg)"
    //         + "skewY(" + this.config['transform'].transform_skewY + "deg)"
    //     }
    //     break;
    //   case 'z':         // --- Xoay phải
    //     if (this.config['transform'].transform_rotateZ < 360)
    //       this.config['transform'].transform_rotateZ += 90;
    //     this.class['icon__primary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg)"
    //       + "rotateY(" + this.config['transform'].transform_rotateY + "deg)"
    //       + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg)"
    //       + "skewX(" + this.config['transform'].transform_skewX + "deg)"
    //       + "skewY(" + this.config['transform'].transform_skewY + "deg)"
    //     break;
    //   default:
    // }

    switch (axis) {
      case 'x': // ---Lật dọc
        if (this.config['transform'].transform_rotateX < 360) {
          this.config['transform'].transform_rotateX += 180;
          this.class['icon__primary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateX -= 360;
          this.class['icon__primary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'y': // ---Lật ngang
        if (this.config['transform'].transform_rotateY < 360) {
          this.config['transform'].transform_rotateY += 180;
          this.class['icon__primary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateY -= 360;
          this.class['icon__primary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case '-z': // --- Xoay trái
        if (this.config['transform'].transform_rotateZ > -360) {
          this.config['transform'].transform_rotateZ -= 45;
          this.class['icon__primary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'z': // --- Xoay phải
        if (this.config['transform'].transform_rotateZ < 360)
          this.config['transform'].transform_rotateZ += 45;
        this.class['icon__primary'].transform =
          'rotateX(' +
          this.config['transform'].transform_rotateX +
          'deg) ' +
          'rotateY(' +
          this.config['transform'].transform_rotateY +
          'deg) ' +
          'rotateZ(' +
          this.config['transform'].transform_rotateZ +
          'deg) ' +
          'skewX(' +
          this.config['transform'].transform_skewX +
          'deg) ' +
          'skewY(' +
          this.config['transform'].transform_skewY +
          'deg) ';
        break;
      default:
    }

    this.updateObject();
  }

  getOption = (compress, compressType) => {
    const types = compress ? {
      1: 'compress-sreen',
      2: 'compress-frame'
    } : {
      1: 'no-compress-all',
      2: 'no-compress-one'
    };

    let option: any = {
      compress_type: types[compressType]
    };

    if (compress) {
      option.resolution = {
        desktop: { width: 300, height: 300 },
        mobile_landscape: {},
        mobile_portrait: {},
        tablet_landscape: {},
        tablet_portrait: {}
      };
    }

    return option;
  }


  handleChange(info: NzUploadChangeParam): void {
    console.log("info >>>", info);
    let option = this.getOption(this.objectChoosing.staticdata.compress, this.objectChoosing.staticdata.compress_type);
    let fileList = [...info.fileList];
    fileList = fileList.slice(-2);
    fileList.map(file => {
      console.log("file >>>", file)
      this.vhImage
        .getImageFromDesktop_Autoweb(
          file.originFileObj,
          'images/design/objects',
          option
        ).then((rsp: any) => {
          console.log("rsp >>>>", rsp)
        })
    });
    console.log("fileList >>>", fileList)
    // this.fileList = fileList;
  }

  //Hàm cập nhật giá trị transform
  SetTransform() {
    this.class['icon__primary'].transform =
      'rotateX(' +
      this.config['transform'].transform_rotateX +
      'deg) ' +
      'rotateY(' +
      this.config['transform'].transform_rotateY +
      'deg) ' +
      'rotateZ(' +
      this.config['transform'].transform_rotateZ +
      'deg) ' +
      'skewX(' +
      this.config['transform'].transform_skewX +
      'deg) ' +
      'skewY(' +
      this.config['transform'].transform_skewY +
      'deg) ';
  }



  /**
 * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
 * @param event customize sau khi thay đổi
 */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[1])
  }
}
